import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const commercetools = defineConnector({
  identifier: "commercetools",
  name: "commercetools",
  tagLine: "Composable commerce platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.[^/]*\\.commercetools\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your commercetools instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your commercetools instance.",
        },
        {
          kind: "input",
          label: "Region",
          placeholder: "us-central1",
          required: true,
          target: { kind: "configuration", field: "region" },
          helperText:
            "The region of your commercetools account. Use the full region identifier (e.g., 'us-central1' for GCP or 'us-east-2' for AWS).",
        },
        {
          kind: "input",
          label: "Project Key",
          placeholder: "demo-project-slug",
          required: true,
          target: { kind: "configuration", field: "projectKey" },
          helperText: "The project key of your commercetools account",
        },
        {
          kind: "input",
          label: "Cloud Provider",
          placeholder: "gcp",
          required: true,
          target: { kind: "configuration", field: "cloudProvider" },
          helperText:
            "Cloud provider used to host your commercetools project (e.g., 'gcp' or 'aws')",
        },
      ],
    },
    {
      title: "Create a commercetools app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [commercetools API client docs](https://docs.commercetools.com/getting-started/create-api-client) and create an API client in the Merchant Center or Admin API. Copy the client ID and client secret, and note the project key, region, and cloud provider for your project.",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: (configuration) =>
      `https://auth.${configuration.region}.${configuration.cloudProvider}.commercetools.com/oauth/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://api.${configuration.region}.${configuration.cloudProvider}.commercetools.com/${configuration.projectKey}/`,
  },
  publicEnvVars: ({ region, projectKey, cloudProvider }) => ({
    COMMERCETOOLS_REGION: region || "",
    COMMERCETOOLS_PROJECT_KEY: projectKey || "",
    COMMERCETOOLS_CLOUD_PROVIDER: cloudProvider || "",
  }),
});
